/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import {
  FETCH_ACTION,
  AGENT_CHAT_REQUEST,
  AGENT_CHAT_RESPONSE,
  AGENT_CHAT_HISTORY_REQUEST,
  AGENT_CHAT_HISTORY_RESPONSE,
  AGENT_CHAT_ADD_MESSAGE,
  AGENT_CHAT_CLEAR,
} from '#constants/actionTypes.js';
import config, { AGENT_CHAT_BASE_URL } from '#support/app/config.js';

export const addChatMessage = (modelId, message) => ({
  type: AGENT_CHAT_ADD_MESSAGE,
  payload: { modelId, message },
});

export const clearChatHistory = (modelId, generation) => ({
  type: AGENT_CHAT_CLEAR,
  payload: { modelId, generation },
});

export const fetchChatHistory = modelId => ({
  [FETCH_ACTION]: {
    types: [AGENT_CHAT_HISTORY_REQUEST, AGENT_CHAT_HISTORY_RESPONSE],
    endpoint: `/model/${modelId}/agent/chat`,
    meta: { modelId },
    options: {
      method: 'GET',
    },
  },
});

export const uploadFileForAgent = (modelId, fileName, mediaType, fileSize) => ({
  [FETCH_ACTION]: {
    types: ['AGENT_UPLOAD_REQUEST', 'AGENT_UPLOAD_RESPONSE'],
    endpoint: `/model/${modelId}/agent/upload`,
    options: {
      method: 'POST',
      body: { fileName, mediaType, fileSize },
    },
  },
});

export const completeMultipartUpload = (modelId, fileKey, s3UploadId, parts) => ({
  [FETCH_ACTION]: {
    types: ['AGENT_UPLOAD_COMPLETE_REQUEST', 'AGENT_UPLOAD_COMPLETE_RESPONSE'],
    endpoint: `/model/${modelId}/agent/upload`,
    options: {
      method: 'POST',
      body: { action: 'complete', fileKey, s3UploadId, parts },
    },
  },
});

const sendAgentMessage = (modelId, message, files) => {
  const agentChatBaseUrl = config(AGENT_CHAT_BASE_URL);
  const endpoint = agentChatBaseUrl
    ? `${agentChatBaseUrl}/model/${modelId}/agent/chat`
    : `/model/${modelId}/agent/chat`;

  const body = { message };
  if (files && files.length > 0) {
    body.files = files;
  }

  return {
    [FETCH_ACTION]: {
      types: [AGENT_CHAT_REQUEST, AGENT_CHAT_RESPONSE],
      endpoint,
      options: {
        method: 'POST',
        body,
      },
    },
  };
};

export default sendAgentMessage;
